import { isBeautyApp } from '@ori/beauty-app-info';
import Cookies from 'js-cookie';

import { app } from './App';
import { Consts } from './consts';
import type { AppConfiguration } from './models/AppConfiguration';
import './index.css';

export const render = (rootElement: HTMLElement): void => {
  if (isBeautyApp() || Cookies.get(Consts.SHOULD_BE_CLOSED_COOKIE)) {
    return;
  }

  const config = rootElement.getAttribute('data-config');
  if (!config) {
    throw new Error('No config provided.');
  }

  const configuration: AppConfiguration = {
    config,
  };
  app(configuration);
};
